exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user {\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-flow: row nowrap;\r\n            flex-flow: row nowrap;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    height: 100%;\r\n\r\n    font-size: 1.5rem;\r\n}\r\n.user__info {\r\n}\r\n.user__name,\r\n.user__email {\r\n    line-height: 1.5rem;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.user__name {\r\n\r\n}\r\n.user__email {\r\n    font-size: 1.2rem;\r\n}\r\n.user__photo {\r\n    height: 40px;\r\n    margin: 0 15px;\r\n    width: 40px;\r\n\r\n    border-radius: 50%;\r\n}\r\n.user__exit-btn {\r\n    height: 40px;\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 20px;\r\n\r\n    border: none;\r\n\r\n    background: url('/assets/img/exit.svg') right center/20px 20px no-repeat;\r\n\r\n    cursor: pointer;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/menu/user-thumb/user-thumb.component.css
// module id = 600
// module chunks = 1